module.exports = __webpack_public_path__ + "c1a13d2b.png";